import { OrganizationDataService } from './../../../../../services/organization-data.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { InstanceDataService } from 'src/app/services/instance-data.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-instance-info-section',
    templateUrl: './instance-info-section.component.html',
    styleUrls: ['./instance-info-section.component.scss'],
    standalone: false
})
export class InstanceInfoSectionComponent implements OnInit, OnDestroy {
    currentOrganizationName: string;
    currentInstanceName: string;
    currentAssetType: string;
    organizationSub: Subscription;
    instanceNameSub: Subscription;
    assetTypeSub: Subscription;
    constructor(
        private organizationDataService: OrganizationDataService,
        private instanceDataService: InstanceDataService
    ) {}

    ngOnInit(): void {
        this.organizationSub = this.organizationDataService.currentOrganizationName.subscribe((orgName: string) => {
            this.currentOrganizationName = orgName;
        });
        this.instanceNameSub = this.instanceDataService.currentInstanceName.subscribe((instanceName: string) => {
            this.currentInstanceName = instanceName;
        });
        this.assetTypeSub = this.instanceDataService.currentAssetType.subscribe((assetType: string) => {
            this.currentAssetType = assetType;
        });
    }

    ngOnDestroy(): void {
        this.assetTypeSub.unsubscribe();
        this.instanceNameSub.unsubscribe();
        this.organizationSub.unsubscribe();
    }
}
